module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-11.jpg?v=fca21124";